// src/pages/admin/adminManage.js

import React, { useState } from 'react';
import { Container } from 'reactstrap';
import { MetaTags } from 'react-meta-tags';
import Breadcrumbs from 'components/Common/Breadcrumb';
import { Card, CardBody, CardTitle } from 'reactstrap';
import { getAdminList,addNewAdmin } from 'helpers/fakebackend_helper';
import { useQuery, useMutation } from 'react-query';

// ... existing code ...

const AdminManage = () => {
    const [admins, setAdmins] = useState([]); // State to hold the list of admins
    const [showForm, setShowForm] = useState(false); // State to toggle the form
    const [newAdmin, setNewAdmin] = useState({ email: '', password: '', name: '' }); // State for new admin input

    const toggleForm = () => {
        setShowForm(!showForm);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNewAdmin({ ...newAdmin, [name]: value });
    };

    const mutation = useMutation(newAdmin => addNewAdmin(newAdmin), {
        onSuccess: () => {
            // Optionally, you can refetch the admin list or perform other actions on success
            refetch();
        },
    });

   

    const handleAddAdmin = () => {
        mutation.mutate(newAdmin); // Use mutation to add new admin
    };

    const { data, isLoading, refetch } = useQuery('adminList', getAdminList, {
        // staleTime: 120000,
          refetchOnWindowFocus: false,
        });
    return (
        <div className="page-content">
        <MetaTags>
          <title>
          Beaconparenting Admin
          </title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Admin Management" breadcrumbItem="" />
            <h1>Admin Management</h1>
            <button 
                onClick={toggleForm} 
                className="btn btn-success"
                style={{ padding: '10px 20px', fontSize: '16px' }}
            >
                {showForm ? 'Cancel' : 'Add Admin'}
            </button>
            {showForm && (
                <Card>
                    <CardBody>
                        <CardTitle tag="h5">Add New Admin</CardTitle>
                        <input
                            type="text"
                            name="name"
                            placeholder="Name"
                            value={newAdmin.name}
                            onChange={handleInputChange}
                            className="form-control mb-2"
                        />
                        <input
                            type="email"
                            name="email"
                            placeholder="Email"
                            value={newAdmin.email}
                            onChange={handleInputChange}
                            className="form-control mb-2"
                        />
                        <input
                            type="password"
                            name="password"
                            placeholder="Password"
                            value={newAdmin.password}
                            onChange={handleInputChange}
                            className="form-control mb-2"
                        />
                        <button  type='button' onClick={handleAddAdmin} className="btn btn-primary">Submit</button>
                    </CardBody>
                </Card>
            )}
                <Card className=' mt-5'>
                <CardBody>

            <table className="table table-nowrap align-middle">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Email</th>
                    </tr>
                </thead>
                <tbody>
                    {data?.admins.map((admin, index) => (
                        <tr key={index}>
                            <td>{admin.name}</td>
                            <td>{admin.email}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
                </CardBody>
                </Card>
        </Container>
        </div>
    );
};

export default AdminManage;